import api from './api';

export type GpuAllocationStatus = {
  enabled: boolean;
  auto_assign: boolean;
  device_count: number;
  device_names: string[];
  stream_assignments: Record<string, number>;
  cctv_overrides: Record<string, number>;
  load_per_gpu: Record<string, number>;
  pool_preferences: Record<string, number[]>;
  max_cams_per_gpu: number;
};

export function streamAssignmentKey(poolId: number, cctvId: number): string {
  return `${poolId}:${cctvId}`;
}

export async function fetchGpuAllocationStatus(): Promise<GpuAllocationStatus> {
  return api.get<GpuAllocationStatus>('/api/gpu/allocation', undefined, {
    silentError: true,
  });
}

export async function setCctvGpuAllocation(
  poolId: number,
  cctvId: number,
  gpuIndex: number,
): Promise<{ ok: boolean; gpu_index: number; cctv_overrides: Record<string, number> }> {
  return api.put('/api/gpu/allocation/cctv', {
    pool_id: poolId,
    cctv_id: cctvId,
    gpu_index: gpuIndex,
  });
}

export function resolveCctvGpuIndex(
  status: GpuAllocationStatus | null | undefined,
  poolId: number,
  cctvId: number,
): number | null {
  if (!status?.enabled) return null;
  const key = streamAssignmentKey(poolId, cctvId);
  if (status.stream_assignments[key] != null) {
    return Number(status.stream_assignments[key]);
  }
  if (status.cctv_overrides[key] != null) {
    return Number(status.cctv_overrides[key]);
  }
  return null;
}
